/* INVOICES */
export const GET_INVOICE_DETAIL = "GET_INVOICE_DETAIL";
export const GET_INVOICE_DETAIL_SUCCESS = "GET_INVOICE_DETAIL_SUCCESS";
export const GET_INVOICE_DETAIL_FAIL = "GET_INVOICE_DETAIL_FAIL";

export const GET_ADVINVOICE_DETAIL = "GET_ADVINVOICE_DETAIL";
export const GET_ADVINVOICE_DETAIL_SUCCESS = "GET_ADVINVOICE_DETAIL_SUCCESS";
export const GET_ADVINVOICE_DETAIL_FAIL = "GET_ADVINVOICE_DETAIL_FAIL";

/* PAYMENT */
export const UPDATE_PAYMENT_INFO = "UPDATE_PAYMENT_INFO";
export const UPDATE_PAYMENT_INFO_SUCCESS = "UPDATE_PAYMENT_INFO_SUCCESS";
export const UPDATE_PAYMENT_INFO_FAIL = "UPDATE_PAYMENT_INFO_FAIL";
